import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  display: flex;
  color: ${(p) => p.theme.palette.grey[700]};
  :hover {
    color: ${(p) => p.theme.palette.primary[500]};
    p {
      color: ${(p) => p.theme.palette.primary[500]};
    }
  }
`;
